<template>
  <ContactForm showAllInfo />
</template>

<script>
import ContactForm from "@/components/ContactForm.vue";
export default {
  components: {
    ContactForm
  }
};
</script>

<style lang="scss" scoped></style>
